import React from "react";
import { ButtonDownloadLog } from "..";
import { toDatetimeStr } from "../../utils/datetime-utils";
import LogItemImage from "./LogItemImage";
import { MAX_FILE_SIZE } from "../../constants/app";

const LogItem = ({ item, apiUrl }) => {
  const userName = `${item.user.name}（${item.user.username}）`;
  const fileSize = item.file_size / (1024*1024)

  return (
    <div className="machine-infor__panel border border-tenken-gray-300">
      <LogItemImage />
      <div className="2xl:w-[170px] xl:w-[165px] relative w-[160px] ml-1 2xl:ml-2.5 xl:ml-1.5">
        <div className="group">
          <h4 className="xl:mb-[10px] mb-2 truncate font-bold">{userName}</h4>
          <div className="font-bold absolute hidden bottom-full bg-blue-200 shadow-lg max-w-xs w-max rounded-lg whitespace-normal border border-blue-300 xl:p-2 p-1 z-10 group-hover:block break-words">{userName}</div>
        </div>
        <p className="xl:mb-[10px] mb-2 whitespace-nowrap font-light">
          更新日: {toDatetimeStr(item.log_time)}
        </p>
        {fileSize < MAX_FILE_SIZE ?
          <ButtonDownloadLog id={item.id} apiUrl={apiUrl} buttonId={`download-log_${item.id}`} /> :
          <div className="xl:w-[140px] xl:h-[36px] w-[124px] h-[30px]"></div>}
      </div>
    </div>
  );
};

export default LogItem;
